import React from 'react';
import { createSelector } from 'reselect';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import lodash from 'lodash';
import { TRANSMISSION_ZONES } from '../../../../appConstants';
import AppFunctionsService from '../../../../services/appFunctionsService';

interface ITransmissionZoneDropdownProps {
    id ?: string;
    value : [number, number] | null;

    onChange ?: (value : [number, number] | null) => void;

    required ?: boolean;
    autoFocus ?: boolean;

    fullWidth ?: boolean;

    label ?: string;
    clearable ?: boolean;
}

interface ITransmissionZoneDropdownState {
}

export default class TransmissionZoneDropdown extends React.Component<ITransmissionZoneDropdownProps, ITransmissionZoneDropdownState> {
    constructor(props : ITransmissionZoneDropdownProps) {
        super(props);

        this.state = {
        };
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : [number, number] | null;
    } | null) => {
        if (this.props.onChange) this.props.onChange(value?.value ?? null);
    };

    private readonly getValue = (state : ITransmissionZoneDropdownState, props : ITransmissionZoneDropdownProps) => props.value;
    private readonly getRequired = (state : ITransmissionZoneDropdownState, props : ITransmissionZoneDropdownProps) => props.required;
    private readonly getClearable = (state : ITransmissionZoneDropdownState, props : ITransmissionZoneDropdownProps) => props.clearable;

    private readonly getTransmissionZoneDropdown = createSelector([
        this.getRequired,
        this.getClearable,
    ], (required, clearable) => {
        const drop : Array<{
            label : string;
            value : [number, number] | null;
        }> = lodash.map(TRANSMISSION_ZONES, n => ({
            label: AppFunctionsService.getTransmissionZoneLabel(n),
            value: n,
        }));

        if (!required && !clearable) {
            drop.unshift({
                label: 'ALL',
                value: null,
            });
        }

        return drop;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue, this.getRequired, this.getClearable,
    ], (value, required, clearable) => {
        if (value) {
            const zone = TRANSMISSION_ZONES.find(x => x === value);

            if (zone) {
                return { label: AppFunctionsService.getTransmissionZoneLabel(zone), value: zone };
            } else {
                return { label: AppFunctionsService.getTransmissionZoneLabel(value), value };
            }
        }

        if (!required && !clearable) {
            return {
                label: 'ALL',
                value: null,
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, fullWidth, id, label = 'Transmission Zone', clearable } = this.props;

        const dropdown = this.getTransmissionZoneDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);
        return (
            <FormControl fullWidth={fullWidth} error={required && !value} required={required}>
                <Autocomplete
                    id={id}
                    options={dropdown}
                    value={value}
                    getOptionSelected={(option, val) => option.label === val.label}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required && !clearable}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth={fullWidth} label={label} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
                <div className='wfill' style={{
                    minHeight: 8,
                }}>
                </div>
            </FormControl>
        );
    };
}
